import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { CreditCardPaymentList, CreditCardSettlementByDate } from './components';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    },
})

const IdentitySelector = (state) => state.Identity;

const CreditCardAdjustment = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();

    // useSelector で store の state を取得。
    const [modeInfo, setModeInfo] = useState({ mode: 'list', start_dt: '', end_dt: '', issuer_name: '', agency_name: '', kind_name: '' });
    const [listRefresh, setListRefresh] = useState(true);

    const { classes } = props;

    /**
     *
     * クレジットカードの売上明細リスト画面表示
     *
     * @param data 選択された行のデータ
     */
    const showList = () => {
        setListRefresh(false);
        setModeInfo({ mode: 'list', start_dt: modeInfo.start_dt, end_dt: modeInfo.end_dt, issuer_name: modeInfo.issuer_name, agency_name: modeInfo.agency_name, kind_name: modeInfo.kind_name })
    }

    /**
     *
     * クレジットカードの売上明細（日別）リスト画面表示
     *
     * @param data 選択された行のデータ
     */
    const showDetail = (startDt, endDt, data) => {
        // 日別リスト画面に表示切替
        setModeInfo({ mode: 'list_daily', start_dt: startDt, end_dt: endDt, issuer_name: data.credit_card_issuer_name, agency_name: data.payment_agency_name, kind_name: data.credit_card_payment_kind_name })
    }

    var listClass = classes.hiddenList;

    if (modeInfo.mode == 'list') {
        listClass = classes.visibleList;
    }

    var content = <div></div>;

    if (modeInfo.mode == 'list_daily') {
        content = <CreditCardSettlementByDate onCancel={showList} startDt={modeInfo.start_dt} endDt={modeInfo.end_dt} issuerName={modeInfo.issuer_name} agencyName={modeInfo.agency_name} kindName={modeInfo.kind_name} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <CreditCardPaymentList onDetail={showDetail} refresh={listRefresh} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(CreditCardAdjustment);
